export const listingsExportPricesUSD = {
  tier1: {
    '1': {
      price: 150,
      priceID: 'price_1PhrlTBVoeq938b5vrNf3SBy',
    },
    '2': {
      price: 300,
      priceID: 'price_1Phrn4BVoeq938b5beJ29jFf',
    },
    '3': {
      price: 450,
      priceID: 'price_1PhrodBVoeq938b5fc5Qhu6h',
    },
  },
  tier2: {
    '1': {
      price: 300,
      priceID: 'price_1Phrn4BVoeq938b5beJ29jFf',
    },
    '2': {
      price: 600,
      priceID: 'price_1PhrowBVoeq938b5ggB1RZ4Q',
    },
    '3': {
      price: 900,
      priceID: 'price_1PhrpIBVoeq938b5A8iCjGcD',
    },
  },
  tier3: {
    '1': {
      price: 500,
      priceID: 'price_1PhrnjBVoeq938b5rPnrHKee',
    },
    '2': {
      price: 1000,
      priceID: 'price_1PhrpfBVoeq938b5n2V0p1jk',
    },
    '3': {
      price: 1500,
      priceID: 'price_1PhrpxBVoeq938b5iwwLDPfO',
    },
  },
};
